import { render, staticRenderFns } from "./gzzj.vue?vue&type=template&id=e0daa700&scoped=true"
import script from "./gzzj.vue?vue&type=script&lang=js"
export * from "./gzzj.vue?vue&type=script&lang=js"
import style0 from "./gzzj.vue?vue&type=style&index=0&id=e0daa700&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0daa700",
  null
  
)

export default component.exports